// src/components/ui/CategoryShimmer.tsx
import React from 'react';

interface CategoryShimmerProps {
  categoryName?: string;
}

export const CategoryShimmer: React.FC<CategoryShimmerProps> = ({ categoryName }) => {
  return (
    <div
      style={{
        backgroundColor: 'white',
        border: '1px solid #E5E7EB',
        borderRadius: '4px',
        padding: 'var(--space-4)',
        textAlign: 'center',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        aspectRatio: '1',
        minHeight: '160px',
        overflow: 'hidden',
      }}
    >
      {/* Animated shimmer effect */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: '-100%',
          width: '200%',
          height: '100%',
          background:
            'linear-gradient(90deg, transparent 0%, rgba(156, 163, 175, 0.1) 50%, transparent 100%)',
          animation: 'shimmer 2s infinite',
        }}
      />

      {/* Processing indicator - Top Right */}
      <div
        style={{
          position: 'absolute',
          top: 'var(--space-2)',
          right: 'var(--space-2)',
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: '#F59E0B',
          animation: 'pulse 1.5s ease-in-out infinite',
        }}
      />

      {/* Content */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'var(--space-2)',
          opacity: 0.5,
        }}
      >
        {/* Placeholder for abbreviation */}
        <div
          style={{
            width: '60px',
            height: '60px',
            backgroundColor: '#F3F4F6',
            borderRadius: '4px',
          }}
        />

        {/* Category name if provided */}
        {categoryName && (
          <div
            style={{
              fontFamily: 'var(--font-primary)',
              fontSize: '10px',
              fontWeight: 'var(--font-semibold)',
              color: '#9CA3AF',
              letterSpacing: '0.8px',
              textTransform: 'uppercase',
              marginTop: 'var(--space-1)',
            }}
          >
            {categoryName}
          </div>
        )}

        {/* Processing text */}
        <div
          style={{
            fontFamily: 'var(--font-primary)',
            fontSize: '10px',
            color: '#F59E0B',
            letterSpacing: '0.3px',
            fontWeight: 'var(--font-medium)',
          }}
        >
          Processing...
        </div>
      </div>

      <style>{`
        @keyframes shimmer {
          0% {
            left: -100%;
          }
          100% {
            left: 100%;
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.5;
            transform: scale(1.2);
          }
        }
      `}</style>
    </div>
  );
};
